import { useState } from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';
import { Mark } from './Mark';

const LINKS = [
  { label: 'The Car Pool', href: '#carpool' },
  { label: 'How it started', href: '#started' },
  { label: 'Listen', href: '#listen' },
  { label: 'About Nyah', href: '#about' },
  { label: 'Booking', href: '#booking' }
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const { scrollYProgress } = useScroll();
  const progress = useSpring(scrollYProgress, { stiffness: 90, damping: 22, mass: 0.4 });

  return (
    <header className="fixed top-0 z-50 w-full border-b border-ivory/10 bg-plum/80 backdrop-blur-2xl">
      <motion.div
        className="absolute inset-x-0 top-0 h-[2px] origin-left bg-gold"
        style={{ scaleX: progress }}
        data-testid="nav-scroll-progress"
      />
      <nav className="mx-auto flex max-w-[1280px] items-center justify-between gap-4 px-6 py-4" aria-label="Main">
        <a href="#" className="flex items-center gap-3 whitespace-nowrap" data-testid="nav-brand-link">
          <Mark size={36} spin />
          <span className="font-display text-lg tracking-wide text-ivory md:text-2xl">
            IT'S FUNKY <span className="text-gold">BABY</span>
          </span>
        </a>

        <div className="hidden items-center gap-7 lg:flex">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.slice(1)}`}
              className="text-[15px] font-semibold text-ivory/80 transition-colors duration-200 hover:text-gold"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <a
            href="#guestlist"
            data-testid="nav-guestlist-cta"
            className="whitespace-nowrap rounded-full bg-mauve px-4 py-3 text-sm font-extrabold text-plum transition-transform duration-200 hover:scale-[1.05] hover:shadow-[0_0_24px_rgba(211,166,207,0.45)] md:px-5 md:text-[15px]"
          >
            <span className="hidden md:inline">Join the guest list</span>
            <span className="md:hidden">Guest list</span>
          </a>
          <button
            type="button"
            aria-label="Menu"
            aria-expanded={open}
            data-testid="nav-menu-toggle"
            onClick={() => setOpen((v) => !v)}
            className="flex h-11 w-11 items-center justify-center rounded-full border border-ivory/15 text-ivory lg:hidden"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
              {open ? <path d="M5 5l14 14M19 5L5 19" /> : <path d="M4 7h16M4 12h16M4 17h16" />}
            </svg>
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-ivory/10 bg-plum/95 px-6 py-4 backdrop-blur-2xl lg:hidden">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-mobile-link-${l.href.slice(1)}`}
              onClick={() => setOpen(false)}
              className="block py-3 font-display text-2xl tracking-wide text-ivory transition-colors duration-200 hover:text-gold"
            >
              {l.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
}
